import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useLanguagesQuery } from 'modules/_common/hooks';
import { ITemplateProps } from 'modules/_common/models';
import { createMailTask } from 'modules/accommodations/features/reservations/api';

export const useCalculationTemplateDetailsQuery = ({
  reservationId,
  templateId,
  isRenter,
}: ITemplateProps) => {
  const {
    isLoading: isLoadingLanguages,
    isError: isErrorLanguages,
    data: languages,
  } = useLanguagesQuery();

  const { data, isError, isLoading } = useQuery(
    [QUERY_KEYS.RENTALS_CALCULATION_TEMPLATE_DETAILS, reservationId, templateId],
    () => createMailTask({ reservationId, templateId, isRenter }),
    {
      enabled: !!reservationId && !!templateId,
      cacheTime: 0,
    },
  );

  return {
    isLoading: isLoadingLanguages || isLoading,
    isError: isErrorLanguages || isError,
    languages,
    data,
  };
};
